import { Link, NavLink } from "react-router-dom";
import { Search } from "lucide-react";

export const NAV_ITEMS = [
  { to: "/", label: "Home", testId: "nav-home", end: true },
  { to: "/blog", label: "Journal", testId: "nav-blog" },
  { to: "/category/origins-and-history", label: "Origins", testId: "nav-origins" },
  { to: "/category/global-tea-regions", label: "Regions", testId: "nav-regions" },
  { to: "/category/brewing-and-the-art-of-tasting", label: "Brewing", testId: "nav-brewing" },
  { to: "/glossary", label: "Glossary", testId: "nav-glossary" },
  { to: "/about", label: "About", testId: "nav-about" },
];

export const linkClass = ({ isActive }) =>
  `text-sm tracking-wide link-underline transition-colors ${
    isActive ? "text-[#1e4a35]" : "text-[#151e1a] hover:text-[#1e4a35]"
  }`;

export function NavLinks({ onNavigate, withTestIds = false }) {
  return NAV_ITEMS.map((item) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.end}
      onClick={onNavigate}
      className={linkClass}
      data-testid={withTestIds ? item.testId : undefined}
    >
      {item.label}
    </NavLink>
  ));
}

export function NavSearch({ q, setQ, onSearch, className, inputClassName, testId }) {
  return (
    <form onSubmit={onSearch} className={className}>
      <Search size={14} className="text-[#66726d]" />
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search"
        className={inputClassName}
        data-testid={testId}
      />
    </form>
  );
}

export function NavAuthLinks({ user, logout, onNavigate, mobile = false }) {
  const base = mobile
    ? "font-mono text-[11px] uppercase tracking-widest"
    : "font-mono text-[10px] tracking-widest uppercase";
  if (user && user.role === "admin") {
    return (
      <>
        <Link to="/admin" onClick={onNavigate} className={`${base} text-[#1e4a35]`} data-testid={mobile ? undefined : "nav-admin"}>
          {mobile ? "Admin Panel" : "Admin"}
        </Link>
        <button
          onClick={() => { logout(); onNavigate?.(); }}
          className={`${base} text-[#66726d] hover:text-[#1e4a35] text-left`}
          data-testid={mobile ? undefined : "nav-logout"}
        >
          Logout
        </button>
      </>
    );
  }
  return (
    <Link to="/admin/login" onClick={onNavigate} className={`${base} text-[#1e4a35]`} data-testid={mobile ? undefined : "nav-login"}>
      Login
    </Link>
  );
}
